import styled from 'styled-components';
// import theme from '../../../common/theme';

const MyStatusStyles = styled.div`
  z-index: 10;
  margin-top: -25px;
`;

export default MyStatusStyles;
